module.exports = __webpack_public_path__ + "img/button_ext_feed.2a020360.png";